import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import Vas from '../../../Vas';
import '../../../css/CustomerCreateContract.css';
import { ExtendedButton,SelectField,TextField,Icon,MessageBox,DateField,AutocompleteField,Checkbox,StepperTable } from 'component-lib';
import { DateTimeHelper,CurrencyConverter,CheckValues,Jump } from 'utils-lib';
import { SchoolsModel,CustomerModel, TariffProductsModel,SchoolYearParamsModel,PaymentsModel,OrderContractModel,Sibling,RequestAjaxClass, TariffPointsModel } from 'models-lib';

const format = require('string-format');
var moment = require('moment');
moment().format();
var contractStartEndDatesSet = false;

class CustomerCreateContract extends Component
{
//#region Komponente
    constructor(props)
    {
        super(props);
        this.state = {};
        this.CustomerId = props.match.params.CustomerId;
        this.state.steps = 5;
        this.state.role = localStorage.getItem('vas_role');
        this.state.CustomerText = '';
       
        this.Sibling1 = new Sibling();
        this.Sibling2 = new Sibling();

        this.Request = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);
        this.Request2 = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);
        this.Request3 = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);
        this.Request4 =  new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);
        this.Request5 =  new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);

        this.PaymentsModel = new PaymentsModel([this],null,this.Request);
        this.CustomerModel = new CustomerModel([this],null,this.Request2);
        this.CustomerAboveModel = new CustomerModel([this],null,this.Request3);
        this.SchoolsModel = new SchoolsModel([this],null,this.Request4);
        this.TariffProductsModel = new TariffProductsModel([this],null,this.Request4);
        this.SchoolYearParamsModel = new SchoolYearParamsModel([this],null,this.Request5);
        
        this.FromTariffPointsModel = new TariffPointsModel([this],"TariffPointFrom",this.Request4);
        this.ToTariffPointsModel = new TariffPointsModel([this],"TariffPointTo",this.Request4);

        this.OrderContractModel = new OrderContractModel([this],null,this.Request);

        this.ContractStartRef = React.createRef();
        this.ContractEndRef = React.createRef();

        this.ValidFromNumberOfMonth = Vas.Config.ValidFromNumberOfMonth;
        this.ValidToNumberOfMonth = Vas.Config.ValidToNumberOfMonth;
    }

    componentDidMount(){
        this.Request.setApiUrl(Vas.ApiUrl);
        this.Request.setApiKey(Vas.ApiKey);
        this.Request.setAuth(true);
        this.Request.setErrorHandler(()=>{
          $("#LoadingIconPopUp").removeClass().addClass('hide');
        });

        this.Request2.setApiUrl(Vas.ApiUrl);
        this.Request2.setApiKey(Vas.ApiKey);
        this.Request2.setAuth(true);
        this.Request2.setErrorHandler(()=>{
          $("#LoadingIconPopUp").removeClass().addClass('hide');
        });

        this.Request3.setApiUrl(Vas.ApiUrl);
        this.Request3.setApiKey(Vas.ApiKey);
        this.Request3.setAuth(true);
        this.Request3.setErrorHandler(()=>{
          $("#LoadingIconPopUp").removeClass().addClass('hide');
        });

        this.Request4.setApiUrl(Vas.ApiUrl);
        this.Request4.setApiKey(Vas.ApiKey);
        this.Request4.setAuth(true);
        this.Request4.setErrorHandler(()=>{
          $("#LoadingIconPopUp").removeClass().addClass('hide');
        });

        this.Request5.setApiUrl(Vas.ApiUrl);
        this.Request5.setApiKey(Vas.ApiKey);
        this.Request5.setAuth(true);
        this.Request5.setErrorHandler(()=>{
          $("#LoadingIconPopUp").removeClass().addClass('hide');
        });
        
        Jump.jump(this.state.steps,1,1);

        this.PaymentsModel.GetPaymentsByCustomerId(this.CustomerId);

        if(this.state.role === "1"){
          this.CustomerModel.GetCustomerById(this.CustomerId);
        } else {
          this.CustomerModel.GetCustomers(localStorage.getItem("SendData"),null,null,"name1",null,"Abo",null,null,null,null,null,localStorage.getItem("Number_CurrentCustomer"),null,null,null);
        }

        let reqField = [];
        let reqSelect = [];
        let reqCheck = [];
        
        if (this.state.role === "1"){
          reqField =[{ Key:this.refs.schoolPlace,Index:6,Step:2 }];
          reqSelect = [
            //{ Key:this.refs.contractStart,Index:5,Step:2 }, 
            //{ Key:this.refs.contractEnd,Index:13,Step:4 },
            { Key:this.refs.Payment,Index:14,Step:5 },
            { Key:this.refs.school,Index:6,Step:2 },
            { Key:this.refs.products,Index:7,Step:2 },
            { Key:this.refs.relations,Index:8,Step:2 }];
          reqCheck=[{ Key:this.refs.AcceptPaymentTerms, Index:15, Step: 4 }]  ;
        } else {
          this.CustomerAboveModel.GetCustomersAboveByCustomerId(this.CustomerId, moment().format("YYYY-MM-DD T 00:00:00"));
          reqField =[
            { Key:this.refs.From,Index:1,Step:1 },
            { Key:this.refs.To,Index:2,Step:1 }];
          reqSelect = [
            //{ Key:this.refs.contractStart,Index:1,Step:1 }, 
            { Key:this.refs.Payment,Index:9,Step:3 },
            { Key:this.refs.Via,Index:3,Step:1 },];
        }

        //this.getSchools();
        this.setState({ requiredFields:reqField, 
            requiredSelectField: reqSelect,
            requiredCeckBox: reqCheck },()=>{ 
              
                for (let i=0; i<this.state.requiredFields.length; i++){
                    if (this.state.requiredFields[i].Key.props.IsRequired){
                        this.state.requiredFields[i].Key.setState({ Label:this.state.requiredFields[i].Key.props.Label + "*" });
                    }
                }

                for (let i=0; i<this.state.requiredSelectField.length; i++){
                    if (this.state.requiredSelectField[i].Key.props.IsRequired){
                        this.state.requiredSelectField[i].Key.setState({ Label:this.state.requiredSelectField[i].Key.props.Label + "*" });
                    }
                }
                $("#LoadingIconPopUp").removeClass().addClass('hide');
        });
    }

    Update(observer)
    {
      let me = this;
        this.setState({},()=>{
          if(observer === "Payment"){
            let payments = this.PaymentsModel.Payments;
            let defaultPayment = '';
            let paymentList = [];
            for (let i = 0; i < payments.length; i++){
                if (payments[i].IsDefaultPaymentMethod !==  false ){
                    defaultPayment = payments[i].BankName + "(" + payments[i].Iban.substring(payments[i].Iban.length-6) + ")";
                }
                paymentList.push({ Key:payments[i].Id, Display:payments[i].BankName + "(" + payments[i].Iban.substring(payments[i].Iban.length-6) + ")" });
            }
            if (me.refs.Payment){
                me.refs.Payment.setState({ Data:paymentList, Default: defaultPayment });
            }
          }
          else if( observer === "Customer"){
            if (localStorage.getItem('vas_role') === "3"){
              let value = this.CustomerModel.Customer;
              me.setState({ CustomerText: <table style={{ textAlign:'justify', marginLeft:'15px' }}>
                <thead>
                  <tr>
                    <th 
                      colSpan={2} 
                      style={{ textAlign:'justify' }}>{Vas.Resources.Labels["ContractFor"]}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      {Vas.Resources.Labels["CustomerNumber"]}:
                    </td>
                    <td>
                      {value.CustomerNumber}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      {Vas.Resources.Labels["Name"]}:
                    </td>
                    <td>
                      {value.Name1}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      {Vas.Resources.Labels["FirstName"]}:
                    </td>
                    <td>
                      {value.Name2}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      {Vas.Resources.Labels["Email"]}:
                    </td>
                    <td>
                      {value.Email}
                    </td>
                  </tr>
                </tbody>
              </table> 
              });
            } 
          }
          else if(observer === "SchoolTickets"){
            let result = this.TariffProductsModel.ProductList;
                   
            // preparation Selectfield
            let selectData = [];
            for (let k = 0; k < result.length;k++){
                selectData.push({ Key: result[k].IdTicket, Display:format('{TicketName} ({TzFromText})',result[k]) });
            }
            if (me.refs.products){
                me.refs.products.setState({ Data: selectData, Icon:'' });
            }
            $("#LoadingIconPopUp").removeClass().addClass('hide');
          }
          else if(observer === "Schools"){
            let data = this.SchoolsModel.Schools;
            if (data){
              let schools = [];
              for (let i= 0; i<data.length; i++){
                  let school = { Key:data[i].Id, Display:data[i].Name1 };
                  schools.push(school);
              }
              me.refs.school.setState({ Data:schools });
            }
            $("#LoadingIconPopUp").removeClass().addClass('hide');
          }
          else if( observer === "SchoolYearParams"){
            
              if (this.SchoolYearParamsModel.SchoolYearBegin === "" && this.SchoolYearParamsModel.SchoolYearEnd === ""){//Schülerticket
                  ReactDOM.render(
                    <table>
                      <tbody>
                        <tr>
                          <td><SelectField
                            AppURL={Vas.ApplicationUrl}
                            me={me}
                            ref={this.ContractStartRef}
                            IsRequired={true}
                            Id={"ContractStart"} 
                            Label={Vas.Resources.Labels["ContractStart"]+'*'}
                            OnChange={()=>{me.setState({ ContractStart: $("#ContractStart").val() }); this.clearAll(1); this.clearAll(2); $("#SchoolPlace").val('')}} />
                          </td>
                          <td />
                        </tr>
                        <tr>
                          <td><SelectField
                            AppURL={Vas.ApplicationUrl}
                            me={me}
                            ref={this.ContractEndRef}
                            IsRequired={false}
                            Id={"ContractEnd"} 
                            Label={Vas.Resources.Labels["ContractEnd"]}
                            OnChange={()=>{me.setState({ ContractEnd: $("#ContractEnd").val() }); }}
                            Tooltip={Vas.Resources.Labels["ContractEndeAfterSchool"]}
                          />
                          </td>
                          <td />
                        </tr>
                      </tbody>
                    </table>

                  ,document.getElementById('StartEndRegio'));
                  this.setState({},()=>{
                    this.setState({},()=>{
                      me.startParams(this.ContractStartRef.current);
                      me.endParams(this.ContractEndRef.current);
                    });
                  });
                  
              } else {//Schulträgerticket
                ReactDOM.render(
                  <table>
                    <tbody>
                      <tr>
                        <td><DateField
                          AppURL={Vas.ApplicationUrl}
                          ChooseDataText={Vas.Resources.Labels["ChooseDate"]}
                          Language={localStorage.getItem("vas_language")}
                          me={me}
                          Editable={true}
                          MinValue={moment()}
                          IsRequired={true}
                          Id={"ContractStart"} 
                          Label={Vas.Resources.Labels["ContractStart"]+'*'}
                          OnBlur={()=>{me.setState({ ContractStart: $("#ContractStart").val() },()=>{me.getContractEndParams();});}} 
                          ref={this.ContractStartRef}
                          />
                        </td>
                        <td />
                      </tr>
                      <tr>
                        <td><TextField
                          AppURL={Vas.ApplicationUrl}
                          me={me}
                          Editable={false}
                          IsRequired={false}
                          Id={"ContractEnd"} 
                          Label={Vas.Resources.Labels["ContractEnd"]}
                          Value={DateTimeHelper.FormatToShortDateString(DateTimeHelper.StringToDate(this.SchoolYearParamsModel.SchoolYearEnd,true,localStorage.getItem('vas_language')))}
                        />
                        </td>
                        <td />
                      </tr>
                    </tbody>
                  </table>

                ,document.getElementById('StartEndRegio'));
                this.setState({},()=>{
                  let reqFields = this.state.requiredFields;
                
                  let exists = false;
                  for(let i = 0; i< reqFields.length; i++){
                    if(reqFields[i].Key.props.Id === "ContractStart"){
                      exists = true;
                    }
                  }
                  if(exists === false){
                    reqFields.push({ Key:this.ContractStartRef.current,Index:9,Step:2 });
                  }
                  me.setState({ requiredFields:reqFields,ContractEnd:DateTimeHelper.FormatToShortDateString(DateTimeHelper.StringToDate(this.SchoolYearParamsModel.SchoolYearEnd,true,localStorage.getItem('vas_language'))) });
                })
                
              }
          }
          else if(observer === "ContractsNrw"){
            if(this.OrderContractModel.Success === true){
              Vas.GetView('OrderSuccess', null, true);
            }else{
              //this.refs.Order.setState({ usable:true });
              $("#LoadingIcon").removeClass().addClass('hide');
            }
          }
          else if(observer === "TariffPointFrom"){
              let result = this.FromTariffPointsModel.TariffPoints;
              let resultArr = [];
              result.forEach(e => {
                  resultArr.push(e.DescriptionLong);
              });
              me.refs.From.setState({ Data:resultArr,Loading:false, Icon:"Close" });
          }
          else if(observer === "TariffPointTo"){
            let result = this.ToTariffPointsModel.TariffPoints;
            let resultArr = [];
            result.forEach(e => {
                resultArr.push(e.DescriptionLong);
            });
            me.refs.To.setState({ Data:resultArr,Loading:false, Icon:"Close" });
          }
          else if(observer === "TariffProducts"){
            let data = me.TariffProductsModel.ProductList;
            let vias = [];

            for (let i = 0; i< data.length; i++){

                let via = { Key:data[i].Price+";"+data[i].PaymentInterval+";"+data[i].IdTicket , Display:data[i].TicketName+" Via: "+data[i].TzViaText };
                vias.push(via);
            }
            me.refs.Via.setState({ Data: vias,Loading:false,Icon:null });
          }
          else if(observer === "Customers"){
            if (localStorage.getItem('vas_role') === "3"){
              if (this.CustomerModel.Customers)
              {         
                this.CustomerModel.Customers.forEach(function(value) {

                  me.setState({ CustomerText: <table style={{ textAlign:'justify', marginLeft:'15px' }}>
                    <thead>
                      <tr>
                        <th 
                          colSpan={2} 
                          style={{ textAlign:'justify' }}>{Vas.Resources.Labels["ContractFor"]}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          {Vas.Resources.Labels["CustomerNumber"]}:
                        </td>
                        <td>
                          {value.CustomerNumber}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          {Vas.Resources.Labels["Name"]}:
                        </td>
                        <td>
                          {value.Name1}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          {Vas.Resources.Labels["FirstName"]}:
                        </td>
                        <td>
                          {value.Name2}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          {Vas.Resources.Labels["Email"]}:
                        </td>
                        <td>
                          {value.Email}
                        </td>
                      </tr>
                    </tbody>
                  </table>});

                });
              }
            }
          }
        });
    }

    jump(id,stepId)//springe zu einem anderen Stepperfeld
    {
      Jump.jump(this.state.steps,id,stepId);
    }

    Close()
    {
        ReactDOM.unmountComponentAtNode(document.getElementById('popupContainer'));
        $("#Content").css("opacity", "1");
    }

    checkFields(){
        if (this.state.requiredFields && this.state.requiredSelectField&& this.state.requiredCeckBox){
            let count=this.state.requiredFields.length+this.state.requiredSelectField.length+ this.state.requiredCeckBox.length;
            if (this.state.requiredFields && this.state.requiredSelectField&& this.state.requiredCeckBox){
                
                let filled = 0;
                let first ={ Key:'',Index :500,Step:0 };
                for (let i = 0;i < this.state.requiredFields.length;i++){
                    if (this.state.requiredFields[i]){
                        if (document.getElementById(this.state.requiredFields[i].Key.props.Id).value.length > 0){
                            filled++;
                        } else {
                          if (this.state.requiredFields[i].Index < first.Index){
                            first = this.state.requiredFields[i];
                          }
                        }
                    }
                }

                for (let k = 0; k < this.state.requiredSelectField.length;k++){
                    if (this.state.requiredSelectField[k]){
                        if (document.getElementById(this.state.requiredSelectField[k].Key.props.Id).selectedIndex > 0){
                            filled++;
                        } else {
                          if (this.state.requiredSelectField[k].Index < first.Index){
                            first = this.state.requiredSelectField[k];
                          }
                        }
                    }
                }
                
                for (let j = 0; j < this.state.requiredCeckBox.length;j++){
                  if (this.state.requiredCeckBox[j]){
                      if (document.getElementById(this.state.requiredCeckBox[j].Key.props.Id).checked === true){
                          filled++;
                      } else {
                        if (this.state.requiredCeckBox[j].Index < first.Index){
                          first = this.state.requiredCeckBox[j];
                        }
                      }
                  }
                }

                //Prüfung der Geschwister
            //OK, wenn alle gefüllt sind bzw. alle nicht gefüllt sind

                if(this.state.role === "1"){
                  let firstSiblingArray = ["nameS1", "firstNameS1", "DateOfBirthS1", "accountNumberS1"];

                  let firstSiblingFields = [
                    { Key:"nameS1",Index:1,Step:1 },
                    { Key:"firstNameS1",Index:2,Step:1 },
                    { Key:"DateOfBirthS1",Index:3,Step:1 },
                    { Key:"accountNumberS1",Index:4,Step:1 }];

                  if (!(((document.getElementById(firstSiblingArray[0]).textLength == 0 || document.getElementById(firstSiblingArray[0]).value.length === 0) &&
                    (document.getElementById(firstSiblingArray[1]).textLength == 0 || document.getElementById(firstSiblingArray[1]).value.length === 0) &&
                    (document.getElementById(firstSiblingArray[2]).textLength == 0 || document.getElementById(firstSiblingArray[2]).value.length === 0) &&
                    (document.getElementById(firstSiblingArray[3]).textLength == 0 || document.getElementById(firstSiblingArray[3]).value.length === 0)) || 
                    ((document.getElementById(firstSiblingArray[0]).textLength > 0  || document.getElementById(firstSiblingArray[0]).value.length > 0)&&
                    (document.getElementById(firstSiblingArray[1]).textLength > 0  || document.getElementById(firstSiblingArray[1]).value.length > 0)&&
                    (document.getElementById(firstSiblingArray[2]).textLength > 0  || document.getElementById(firstSiblingArray[2]).value.length > 0)&&
                    (document.getElementById(firstSiblingArray[3]).textLength > 0  || document.getElementById(firstSiblingArray[3]).value.length > 0)))) 
                  {
                    count++;

                    for (let i = 0; i < firstSiblingArray.length; i++)
                    {
                      if ((document.getElementById(firstSiblingArray[i]).textLength == 0 && firstSiblingFields[i].Index < first.Index) || 
                      (document.getElementById(firstSiblingArray[i]).value.length === 0 && firstSiblingFields[i].Index < first.Index)) {
                        first = firstSiblingFields[i];
                      }
                    }
                  }

                  let secondSiblingArray = ["nameS2", "firstNameS2", "DateOfBirthS2", "accountNumberS2"];

                  let secondSiblingFields = [
                    { Key:"nameS2",Index:5,Step:1 },
                    { Key:"firstNameS2",Index:6,Step:1 },
                    { Key:"DateOfBirthS2",Index:7,Step:1 },
                    { Key:"accountNumberS2",Index:8,Step:1 }];

                  if (!(((document.getElementById(secondSiblingArray[0]).textLength == 0 || document.getElementById(secondSiblingArray[0]).value.length === 0) &&
                    (document.getElementById(secondSiblingArray[1]).textLength == 0 || document.getElementById(secondSiblingArray[1]).value.length === 0) &&
                    (document.getElementById(secondSiblingArray[2]).textLength == 0 || document.getElementById(secondSiblingArray[2]).value.length === 0) &&
                    (document.getElementById(secondSiblingArray[3]).textLength == 0 || document.getElementById(secondSiblingArray[3]).value.length === 0)) || 
                    ((document.getElementById(secondSiblingArray[0]).textLength > 0  || document.getElementById(secondSiblingArray[0]).value.length > 0)&&
                    (document.getElementById(secondSiblingArray[1]).textLength > 0  || document.getElementById(secondSiblingArray[1]).value.length > 0)&&
                    (document.getElementById(secondSiblingArray[2]).textLength > 0  || document.getElementById(secondSiblingArray[2]).value.length > 0)&&
                    (document.getElementById(secondSiblingArray[3]).textLength > 0  || document.getElementById(secondSiblingArray[3]).value.length > 0)))) 
                  {
                      count++;

                      for (let i = 0; i < secondSiblingArray.length; i++)
                      {
                        if ((document.getElementById(secondSiblingArray[i]).textLength == 0 && secondSiblingFields[i].Index < first.Index) || 
                      (document.getElementById(secondSiblingArray[i]).value.length === 0 && secondSiblingFields[i].Index < first.Index)) {
                          first = secondSiblingFields[i];
                        }
                      }
                  }
                }
              
                if (filled < count){

                  let id = first.Key.props == undefined ? first.Key : first.Key.props.Id;

                    let docs=document.querySelectorAll('select,input');
                    let docRefs = this.refs;
                    CheckValues.checkAllFields(docs,docRefs,"");
                    ReactDOM.render(<MessageBox
                      Message={Vas.Resources.Labels["NotAllFields"]}
                      Title={Vas.Resources.Titles["Note"]}
                      Click={()=>{
                        this.jump(first.Step);
                        document.getElementById(id).focus();
                      }} />,document.getElementById('messageContainer'));
                } else {
                    this.Order();
                }
            }
        }
    }

    //#endregion

    //#region Geschwister
      addSibling(){
        if (document.getElementById("sibling2").className === "LegalGuardianNotVisible"){
            if ($("#nameS1").val().length > 0 && $("#firstNameS1").val().length > 0 && $('#DateOfBirthS1').val().length > 0){
                $("#sibling2").removeClass().addClass('LegalGuardianVisible');
                this.refs.IconAddSibling.setState({ Name:"Remove" });
            } else {
                ReactDOM.render(<MessageBox
                  Message={Vas.Resources.Labels["NoSibling1"]}
                  Title={Vas.Resources.Titles["Note"]} />,document.getElementById('messageContainer'));
            }
        } else {
            this.Sibling2={
              Name1 : '',
              Name2 : '',
              DateOfBirth : '',
              CustomerNumber : ''
            };
            $("#nameS2").val('');
            $("#firstNameS2").val('');
            $('#DateOfBirthS2').val('');
            $('#accountNumberS2').val('');
            $("#sibling2").removeClass().addClass('LegalGuardianNotVisible');
            this.refs.IconAddSibling.setState({ Name:"Add" });
            this.numberSibling();
            this.siblingSetRequiredSymbol("2");
            if (document.getElementById('Product').selectedIndex > 0){
                this.getContractEndParams();
                this.getProducts();
            }
        }
      }

      getSiblings(){
        let i = 0;
        if ($("#nameS1").val().length > 0 && $("#firstNameS1").val().length > 0 && $('#DateOfBirthS1').val().length > 0 && $('#accountNumberS1').val().length > 0){
          i++;
        }
        
        if ($("#nameS2").val().length > 0 && $("#firstNameS2").val().length > 0 && $('#DateOfBirthS2').val().length > 0 && $('#accountNumberS2').val().length > 0){
          i++;
        }
          
        return i;
      }

      numberSibling(){
      let oldCount = 0;
      if (this.state.numberSibling){
        oldCount = this.state.numberSibling;
      }

      let count = this.getSiblings();
    
      if (oldCount !== count){
        this.clearAll(0);
      }

      this.setState({ numberSibling:count });
      }

      clearAll(index){
      if (index < 4){
        this.refs.relations.setState({ Data:null });
      }
      if (index < 3){
        this.refs.products.setState({ Data:null });
        //ReactDOM.unmountComponentAtNode(document.getElementById('StartEndRegio'));
      }
      if (index < 2){
        this.refs.school.setState({ Data:null });
        
      }
      if (index < 1){
        document.getElementById("SchoolPlace").value = '';
      }

      this.refs.productPrice.setState({ Value:'' });
      this.refs.from.setState({ Value:'' });
      this.refs.to.setState({ Value:'' });
      this.refs.via.setState({ Value:'' });

      let reqFields = this.state.requiredFields;
       let idx = -1;
       for(let i = 0; i< reqFields.length; i++){
         if(reqFields[i].Key.props.Id === "ContractStart"){
           idx = i;
         }
       }
       
       if(idx > -1){
         reqFields.splice(idx,1);
         this.setState({ requiredFields:reqFields});
       }else{
          let reqSelectField = this.state.requiredSelectField;
          for(let i = 0; i< reqSelectField.length; i++){
            if(reqSelectField[i].Key.props.Id === "ContractStart"){
              idx = i;
            }
          }
          if(idx > -1){
            reqSelectField.splice(idx,1);
            this.setState({ requiredSelectField:reqSelectField});
          }
       } 
    }

    siblingSetRequiredSymbol(inputIdNumber){

      let fieldLabelArray = ["nameS", "firstNameS", "DateOfBirthS", "accountNumberS"];

      //Wenn ein Feld (Name, Vorname, Geburtsdatum, Kundennummer) gefüllt ist, alle Label um einen * erweitern

      //Prüfen, ob schon ein * vorhanden ist

      //Wenn alle Felder (Name, Vorname, Geburtsdatum, Kundennummer) leer sind, bei allen Labeln den * entfernen

      let numberOfEmptyFileds = 0;

      fieldLabelArray.forEach(element => {

        let inputField = document.getElementById(element + inputIdNumber);

        if (inputField.textLength == 0 || inputField.value.length === 0) {
          numberOfEmptyFileds ++;
        }
      });

      fieldLabelArray.forEach(element =>{

        let inputField = document.getElementById(element + inputIdNumber);

        let fieldLabel = inputField.parentElement.parentElement.firstChild;

        if (numberOfEmptyFileds === fieldLabelArray.length)
        {
          let innerTextArray = fieldLabel.innerText.split('*');
          
          fieldLabel.innerText = innerTextArray[0];
        }
        else {
          if (fieldLabel.innerText.indexOf('*') === -1) {
              
            let text = fieldLabel.innerText;
  
            fieldLabel.innerText = text + '*';
          }
        }
      });


    }
    //#endregion

    //#region fill Fields

        getSchools() //nach Eingabe des Ortes, hole Schulen
        {
            $("#LoadingIconPopUp").removeClass().addClass('loaderSmall');
            this.Request4.setErrorHandler((result)=>{});
            this.SchoolsModel.GetSchoolsByCity(this.state.schoolPlace);
        }

        getProducts() // nach der Auswahl der Schule, hole Tarifprodukte aus Datenbank
        {
          this.clearRelation();
          $("#LoadingIconPopUp").removeClass().addClass('loaderSmall');
          this.refs.relations.setState({ Data:'' });
          let me = this;
          
          this.setState({ SchoolId : $("#Schools2").val() },()=>{
              if (document.getElementById("Schools2").selectedIndex >0)
              {
                  let date2 = '';
                  if (this.state.ContractStart){
                      date2 = DateTimeHelper.StringToDate(this.state.ContractStart,false,localStorage.getItem('vas_language'));
                      date2 = moment([date2.year(),date2.month(),date2.date()]).format('YYYY-MM-DD T 00:00:00');
                  } else {
                      date2 = moment();
                      date2 = moment([date2.year(),date2.month(),date2.date()]).format('YYYY-MM-DD T 00:00:00');
                  }
                  
                  me.refs.products.setState({ Icon:"Loop" });
                  let curCustomerDateOfBirth = DateTimeHelper.StringToDate(this.CustomerModel.Customer.DateOfBirth,true,localStorage.getItem('vas_language'));
                  
                  this.Request4.setErrorHandler(()=>{
                    $("#LoadingIconPopUp").removeClass().addClass('hide');
                  });

                  //VAS-31647 Hier die fehlende Konvertierung des Geburtsdatums der Geschisterkinder ergänzt
                  if(this.Sibling1.DateOfBirth !== ""){
                    let date = DateTimeHelper.StringToDate(this.Sibling1.DateOfBirth,false,localStorage.getItem('vas_language'));
                    this.Sibling1.DateOfBirth = moment([date.year(),date.month(),date.date()]).format('YYYY-MM-DD T 00:00:00');
                  }
  
                  if(this.Sibling2.DateOfBirth !== ""){
                    let date = DateTimeHelper.StringToDate(this.Sibling2.DateOfBirth,false,localStorage.getItem('vas_language'));
                    this.Sibling2.DateOfBirth = moment([date.year(),date.month(),date.date()]).format('YYYY-MM-DD T 00:00:00');
                  }

                  this.TariffProductsModel.GetSchoolTickets(
                      $("#Schools2").val(),
                      date2,
                      moment([curCustomerDateOfBirth.year(),curCustomerDateOfBirth.month(),curCustomerDateOfBirth.date()]).format('YYYY-MM-DD T 00:00:00'),
                      [this.Sibling1,this.Sibling2]
                  );
                
              } else {
                  me.setState({ Products:'' },()=>{
                      me.refs.products.setState({ Data:'' });
                      $("#LoadingIconPopUp").removeClass().addClass('hide');
                  });
              }
          });
        }

        getRelation() //nach Auswahl des Tarifproduktes, hole Geltungsbereich (Via)
        {
            this.refs.relations.setState({ Icon:"Loop" });
            let selectedProduct = $("#Product").val();
            this.setState({ ProductId:selectedProduct },()=>{
                let selectData = [];
                if (selectedProduct !== "")
                {
                    for (let i = 0; i < this.TariffProductsModel.ProductList.length; i++){
                        if (this.TariffProductsModel.ProductList[i].IdTicket === selectedProduct)
                        {
                            // eslint-disable-next-line
                            selectData.push({ Key: this.TariffProductsModel.ProductList[i].IdTicket, Display: this.TariffProductsModel.ProductList[i].TzFromText+"("+ this.TariffProductsModel.ProductList[i].IdendTzFrom +")" + " - " + this.TariffProductsModel.ProductList[i].TzToText+"("+ this.TariffProductsModel.ProductList[i].IdendTzTo +")" });
                            break;
                        }
                    }
                }
                this.refs.relations.setState({ Data: selectData,Icon:'' },()=>{
                    document.getElementById("Relation").selectedIndex = 1;
                    this.setRelation();
                });
            });
        }

        setRelation(){ // nach Auswahl eines Geltungsbereiches, lege Werte für Felder Preis, Von, Nach und Via fest
            $("#LoadingIconPopUp").removeClass().addClass('loaderSmall');
            this.clearRelation();
            if (this.refs.relations.state.Data.length > 0)
            {
                let productIndex = document.getElementById("Product").selectedIndex - 1;
                this.refs.productPrice.setState({ Value:CurrencyConverter.Cast(this.TariffProductsModel.ProductList[productIndex].Price,localStorage.getItem('vas_language'),2) });
                this.refs.from.setState({ Value:this.TariffProductsModel.ProductList[productIndex].TzFromText + "( " + this.TariffProductsModel.ProductList[productIndex].IdendTzFrom+ " )" });
                this.refs.to.setState({ Value:this.TariffProductsModel.ProductList[productIndex].TzToText + "( " + this.TariffProductsModel.ProductList[productIndex].IdendTzTo+ " )" });
                this.refs.via.setState({ Value:this.TariffProductsModel.ProductList[productIndex].TzViaText + "( " + this.TariffProductsModel.ProductList[productIndex].IdendTzVia+ " )" });

                this.TariffProductsModel.SelectedProductId = productIndex;
                $("#LoadingIconPopUp").removeClass().addClass('hide');
            } else {
                $("#LoadingIconPopUp").removeClass().addClass('hide');
            }
        }

        clearRelation(){//Lösche vorhandenen Relation
          this.TariffProductsModel.SelectedProductId = -1;
        }

    //#endregion

    //#region get data für Vertragsstart und -ende

      getContractEndParams() //holt mögliche Daten für Vertragsstart und Vertragsende
      {
        let me = this;
        if (this.state.role === "1"){//Bestellung als Endkunde
          //if ($("#Product")[0].selectedIndex >= 0){
            if (me.state.schoolPlace !== "")
            {
              let contractStart = moment().format('YYYY-MM-DD T 00:00:00');
              if (this.state.ContractStart){
                let curContractStart = DateTimeHelper.StringToDate(this.state.ContractStart,false,localStorage.getItem('vas_language'));
                contractStart = moment([curContractStart.year(),curContractStart.month(),curContractStart.date()]).format('YYYY-MM-DD T 00:00:00');
              }
                //me.refs.Order.setState({ usable:true });
                //this.SchoolYearParamsModel.GetSchoolYearParams(this.state.SchoolId,$("#Product").val(),contractStart);
                this.Update("SchoolYearParams");
            }
          //}
        } else { //Bestllung als Sachbearbeiter
          if ($("#Via")[0].selectedIndex >= 0){
            let contractStart = moment().format('YYYY-MM-DD T 00:00:00');
            if (this.state.ContractStart){
              let curContractStart = DateTimeHelper.StringToDate(this.state.ContractStart,false,localStorage.getItem('vas_language'));
              contractStart = moment([curContractStart.year(),curContractStart.month(),curContractStart.date()]).format('YYYY-MM-DD T 00:00:00');
            }
            //me.refs.Order.setState({ usable:true });
            let product = '';
            
            if (document.getElementById('Product')){
              product = $("#Product").val();
            } else {
              product = $("#Via").val().split(';')[2];
            }

            let validCustomerAbove = '';
            let valid = false;
            if (this.CustomerAboveModel.CustomersAbove.length > 0){ //Bestellung als Sachbearbeiter
              for (let i = 0; i< this.CustomerAboveModel.CustomersAbove.length; i++){
                if (DateTimeHelper.StringToDate(this.state.ContractStart,false,localStorage.getItem('vas_language')).isAfter(moment(this.CustomerAboveModel.CustomersAbove[i].ValidFrom))){
                  validCustomerAbove = this.CustomerAboveModel.CustomersAbove[i];
                  valid = true;
                }
              }
              if (valid === false){
                contractStart = this.CustomerAboveModel.CustomersAbove[0].ValidFrom;
                validCustomerAbove = this.CustomerAboveModel.CustomersAbove[0];
              }

              this.setState({ SchoolId:validCustomerAbove.Id });
              this.Request5.setErrorHandler((result)=>{
                if (result.responseJSON.ErrorCode !== '1307'){
                  me.refs.Order.setState({ usable:false });
                  ReactDOM.render(<MessageBox
                    Message={Vas.Resources.Labels["OrderError"]}
                    Title={Vas.Resources.Titles["Error"]} />,
                      document.getElementById('messageContainer'));
                }
              });
              this.Update("SchoolYearParams");
            }
          }
        }

        contractStartEndDatesSet = true;
      }

      startParams(startRef){// Lege Startparameter für Vertrag fest
        let today = moment();
        let start = [{ Key: DateTimeHelper.FormatToShortDateString(moment([today.year(),today.month(),1])) ,Display:DateTimeHelper.FormatToShortDateString(moment([today.year(),today.month(),1])) }];

        for (let i = 1; i <= this.ValidFromNumberOfMonth; i++){
          start.push({ Key:DateTimeHelper.FormatToShortDateString(moment([today.year(),today.month(),1]).add(i,'months')) ,
                      Display:DateTimeHelper.FormatToShortDateString(moment([today.year(),today.month(),1]).add(i,'months')) });
        }
      startRef.setState({ Data:start });

      let reqFields = this.state.requiredSelectField;

      let exists = false;
      
      for(let i = 0; i< reqFields.length; i++){
        if(reqFields[i].Key.props.Id === "ContractStart"){
          exists = true;
        }
      }
      if(exists === false){
        reqFields.push({ Key:startRef,Index:9,Step:2 });
      }
        
      this.setState({ requiredSelectField:reqFields });
      }

      endParams(endRef){ //Lege Endparameter für Vertrag fest
        let today = moment().add(1,'year');

          let start = [{ Key: DateTimeHelper.FormatToShortDateString(moment([today.year(),today.month(),DateTimeHelper.GetLastDayOfMonth(today.month(),today.year())])) ,Display:DateTimeHelper.FormatToShortDateString(moment([today.year(),today.month(),DateTimeHelper.GetLastDayOfMonth(today.month(),today.year())])) }];

          for (let i = 1; i <= this.ValidToNumberOfMonth; i++){

            today.add(1, 'month');

            start.push({ Key:DateTimeHelper.FormatToShortDateString(moment([today.year(),today.month(),DateTimeHelper.GetLastDayOfMonth(today.month(),today.year())])) ,
                        Display:DateTimeHelper.FormatToShortDateString(moment([today.year(),today.month(),DateTimeHelper.GetLastDayOfMonth(today.month(),today.year())])) });
          }

          endRef.setState({ Data:start });
      }

//#endregion

      Order()//Bestellen
      {
          $("#LoadingIconPopUp").removeClass().addClass('loaderSmall');

          console.log(this.CustomerModel.Customer);

          this.OrderContractModel.Customer = this.CustomerModel.Customer;
          let paymentId = $("#Payments").val();
          let selPayment = '';
          for (let i =0; i< this.PaymentsModel.Payments.length; i++){
              if (this.PaymentsModel.Payments[i].Id === paymentId){
                  selPayment = this.PaymentsModel.Payments[i];
              }
          }
          this.OrderContractModel.CustomerPaymentOption =  selPayment;
          this.OrderContractModel.CreateAccount = false;
          this.OrderContractModel.DeliveryToSchool = false;
          this.OrderContractModel.SchoolId = this.state.SchoolId;
          this.OrderContractModel.SiblingChildren = [this.Sibling1 , this.Sibling2];

          let curContractStart = DateTimeHelper.StringToDate(this.state.ContractStart,false,localStorage.getItem('vas_language'));
          this.OrderContractModel.ContractStart =  moment([curContractStart.year(),curContractStart.month(),curContractStart.date()]).format('YYYY-MM-DD T 00:00:00');

          if (this.state.ContractEnd){
            let curContractEnd = DateTimeHelper.StringToDate(this.state.ContractEnd,false,localStorage.getItem('vas_language'));
            this.OrderContractModel.ContractEnd = moment([curContractEnd.year(),curContractEnd.month(),curContractEnd.date()]).format('YYYY-MM-DD T 00:00:00');
          } else {
            this.OrderContractModel.ContractEnd = null;
          }

          if (this.state.role === "1"){
            this.OrderContractModel.TariffProduct = this.TariffProductsModel.ProductList[this.TariffProductsModel.SelectedProductId];
            this.OrderContractModel.TariffPointFrom = null;
            this.OrderContractModel.TariffPointTo = null;
          }else{
            this.OrderContractModel.TariffPointFrom = this.TariffProductsModel.TariffPointFrom;
            this.OrderContractModel.TariffPointTo = this.TariffProductsModel.TariffPointTo;

            this.OrderContractModel.TariffProduct = this.TariffProductsModel.ProductList[document.getElementById('Via').selectedIndex-1];
          }

          this.Request.setErrorHandler(()=>{
            ReactDOM.render(<MessageBox
              Message={Vas.Resources.Labels["OrderError2"]}
              Title={Vas.Resources.Titles["Note"]}
              />,document.getElementById('messageContainer'));
              $("#LoadingIconPopUp").removeClass().addClass('hide');
          });

          document.getElementById("btoOrder").disabled = true;
          $("#btoOrder").removeClass().addClass("grayButton");

          this.OrderContractModel.ContractsNrw();
      }

    //#region Bestellung als Sachbearbeiters
      //#region TariffPoints
        Search(field){//Suche nach TariffPoint nach Eingabe von mind 3 Zeichen und einer Wartezeit von 1s

          let me = this;
          if ($("#"+field).val().length >= 3){
              this.TimeOut = window.setTimeout(function(){
                  me.GetStation($("#"+field).val(),field);
              },1000);
          } else {

              if ($("#"+field).val().length === 0){
                  this.refs.Via.setState({ Data: null });
                  $("#Price").val('');
              }
          }
        }

        GetStation(search,id){ //Suche des TariffPoint
            this.refs[id].setState({ Loading:true,Icon:"" });
            let curContractStart = DateTimeHelper.StringToDate(this.state.ContractStart,false,localStorage.getItem('vas_language'));
            if(id === "From"){
              this.FromTariffPointsModel.GetTariffPoints(search,moment([curContractStart.year(),curContractStart.month(),curContractStart.date()]).format("YYYY-MM-DD T 00:00:00"));
            }else if(id === "To"){
              this.ToTariffPointsModel.GetTariffPoints(search,moment([curContractStart.year(),curContractStart.month(),curContractStart.date()]).format("YYYY-MM-DD T 00:00:00"));
            }
        }

        setVisibleToVia(){

          let from = document.getElementById("From");
          let to = document.getElementById("To");
          let via = document.getElementById("Via");

          //Hier Function: von GetVia au SetVisible umstellen und innerhalb SetVisible die Methode GetVia aufrufen
          if (document.getElementById("ContractStart").selectedIndex > 0){
              //this.setState({ Beginn:true });
              this.refs.From.setState({ Icon:"Close",OnClick: ()=>{this.Search("From");},editable:true,OnChange:()=>{this.Search("From");},Function:()=>{this.setVisibleToVia();} });

              from.style.backgroundColor = "white";
          }


          if ($("#From").val() !== ''){
              this.refs.To.setState({ Icon:"",Data:null,editable:false });

              this.refs.To.setState({ Icon:"Close",OnIconClick:()=>{this.Search("To");},editable:true,OnChange:()=>{this.Search("To");},Function:()=>{this.setVisibleToVia();} });

              to.style.backgroundColor = "white";
          }

          if ($("#To").val() !== ''){

              this.refs.Via.setState({ Icon:"",Data:null,editable:false });

              //this.refs.Via.setState({ OnChange:()=>{this.setState({ Via:$("#Via").val() },()=>{this.setPrice();});} });

              via.style.backgroundColor = "white";
          }

          this.GetVia();
        }

        setVisible(){//nach dem Auswählen eines Startdatums werden die Felder für TariffPoints zur Bearbeitung frei gegeben

          //this.setState({ Beginn:false });

          let from = document.getElementById("From");
          let to = document.getElementById("To");
          let via = document.getElementById("Via");

          //Hier Function: von GetVia au SetVisible umstellen und innerhalb SetVisible die Methode GetVia aufrufen
          if (document.getElementById("ContractStart").selectedIndex > 0){
              
              //this.setState({ Beginn:true });

              $("#From").val('');

              this.refs.From.setState({ Icon:"Close",OnIconClick: ()=>{this.Search("From");},editable:true,OnChange:()=>{this.Search("From");},Function:()=>{this.setVisibleToVia();} });

              from.style.backgroundColor = "white";

              $("#To").val('');
              this.refs.To.setState({ Icon:"",Data:null,editable:false });

              $("#Via").val('');
              this.refs.Via.setState({ Icon:"",Data:null,editable:false });

              $("#Price").val('');
              this.refs.Price.setState({ Value:'' });

              to.style.backgroundColor = "lightgray";
              
              via.style.backgroundColor = "lightgray";
          }
          else {
            
              $("#From").val('');
              this.refs.From.setState({ Icon:"",Data:null,editable:false });

              $("#To").val('');
              this.refs.To.setState({ Icon:"",Data:null,editable:false });

              $("#Via").val('');
              this.refs.Via.setState({ Icon:"",Data:null,editable:false });

              $("#Price").val('');

              from.style.backgroundColor = "lightgray";

              to.style.backgroundColor = "lightgray";
              
              via.style.backgroundColor = "lightgray";

              this.removePrice();
          }
        }
      //#endregion

      //#region TariffProducts
      GetVia(){//suche TariffProduct
        
          $("#Price").val('');
          this.refs.Via.setState({ Data: null },()=>{
              let from = {};
              let to = {};

              let resultFrom = this.FromTariffPointsModel.TariffPoints;
              for (let i = 0; i< resultFrom.length; i++){
                  if (resultFrom[i].DescriptionLong === $("#From").val()){
                      from = resultFrom[i];
                      break;
                  }
              }
              let resultTo = this.ToTariffPointsModel.TariffPoints;
              for (let i = 0; i < resultTo.length; i++){
                  if ( resultTo[i].DescriptionLong === $("#To").val()){
                      to = resultTo[i];
                  }
              }
              if ((to.Id !== undefined)&&(from.Id !== undefined)){    
                this.refs.Via.setState({ Icon:"Loop" });     
                this.TariffProductsModel.GetTariffProducts(from,to);
              }
          });

          this.removePrice();
      }

      setPrice(){//holt Preis des gewählten TariffProducts und gibt diesen aus

          if (document.getElementById("Via").selectedIndex > 0){
            /*if (this.TariffProductsModel.ProductList[document.getElementById("Via").selectedIndex-1].ContractEnd!== null){
            } */
              let priceInfoArr = $("#Via").val().split(';');

              let priceInfoDefault = " " +Vas.Resources.Labels["inEuro"];
              let priceInfo = '';

              switch (priceInfoArr[1]){
                  case "1":
                      priceInfo = Vas.Resources.Labels["WeeklyPrice"]+ " " + priceInfoDefault;
                  break;
                  case "2":
                      priceInfo = Vas.Resources.Labels["BiweeklyPrice"]+ " " + priceInfoDefault;
                  break;
                  case "3":
                  default:
                      priceInfo = Vas.Resources.Labels["MonthlyPrice"]+ " " + priceInfoDefault;
                  break;
                  case "4":
                      priceInfo = Vas.Resources.Labels["QuarterlyPrice"]+ " " + priceInfoDefault;
                  break;
                  case "5":
                      priceInfo = Vas.Resources.Labels["SemiannualPrice"]+ " " + priceInfoDefault;
                  break;
                  case "6":
                      priceInfo = Vas.Resources.Labels["AnnualPrice"]+ " " + priceInfoDefault;
                  break;
              }

              document.getElementById('PriceInformation').children[0].children[0].innerHTML = priceInfo;

              this.refs.Price.setState({ Value:CurrencyConverter.Cast(priceInfoArr[0],localStorage.getItem('vas_language'),2) });
              //$("#Price").val(CurrencyConverter.Cast($("#Via").val(),localStorage.getItem('vas_language'),2));
              
          }
          else {
              this.refs.Price.setState({ Value:'' });
          }
      }

    //#endregion

      removePrice(){//Aufruf, wenn To in Preisinformation zuvor gecleared wurde
            
        if ($("#Via").val() == null){
            this.refs.Price.setState({ Value:'' });
        }
      }
    //#endregion
    
    //#region stepper 
      setStepperSiblings(){
        let maxValue = moment(); //maxValue gür Geburtsdatums DatePicker, es darf kein Wert nach heute eingebenen werden
        let min = moment();
        //let minValue = moment([2001,0,31]);
        let minValue = moment([min.year() - 18, min.month(), min.date() + 1]); //minValue für Geburtsdatums Datepicker der Geschwister und der bestellenden Person, sie dürfen nicht älter als 18 Jahre sein
      
        return(
          <div>
            <table style={{ width:'350px' }}>
              <tbody>
                <tr>
                  <td colSpan={2}><p style={{ textAlign: 'left' }}><b>{Vas.Resources.Titles["Note"]}: </b><i className={"HintFormat"}>{Vas.Resources.Labels["FieldsOptional"]}</i><br/></p> </td>
                </tr>
                <tr><td colSpan="2"><b>{Vas.Resources.Labels["Child1"]}</b></td></tr>
                <tr>
                  <td><TextField
                    AppURL={Vas.ApplicationUrl}
                    Editable={true}
                    Id="nameS1"
                    Label={Vas.Resources.Labels["Name"]}
                    OnChange={()=>{ this.Sibling1.Name1 = $("#nameS1").val();}}
                    Modus={"Name"} 
                    OnBlur={()=>{this.numberSibling();this.siblingSetRequiredSymbol("1");}}
                    /></td>
                  <td><TextField
                    AppURL={Vas.ApplicationUrl}
                    Editable={true}
                    Id="firstNameS1"
                    Label={Vas.Resources.Labels["FirstName"]}
                    OnChange={()=>{ this.Sibling1.Name2 = $("#firstNameS1").val();}} 
                    Modus={"Name"}
                    OnBlur={()=>{this.numberSibling();this.siblingSetRequiredSymbol("1");}}
                    /></td>
                </tr>
                <tr>
                  <td><DateField
                    AppURL={Vas.ApplicationUrl}
                    Language={localStorage.getItem("vas_language")}
                    Editable={true}
                    Id={"DateOfBirthS1"}
                    MaxValue={maxValue}
                    MinValue={minValue}
                    Tooltip={Vas.Resources.Tooltips["DateOfBirth"]} 
                    Label={Vas.Resources.Labels["DateOfBirth"]}
                    OnBlur={()=>{ this.Sibling1.DateOfBirth = $("#DateOfBirthS1").val() ; this.numberSibling();this.siblingSetRequiredSymbol("1");}}
                    FalseMaxDateText={Vas.Resources.Labels["NoFutureDateOfBirth"]}
                    FalseMinDateText={Vas.Resources.Labels["InvalidDateOfBirth"]} /></td>
                  <td><TextField
                    AppURL={Vas.ApplicationUrl}
                    Editable={true}
                    Id="accountNumberS1"
                    Label={Vas.Resources.Labels["CustomerNumber"]}
                    OnChange={()=>{ this.Sibling1.CustomerNumber = $("#accountNumberS1").val();this.siblingSetRequiredSymbol("1");}} /></td>
                </tr>
                <tr>
                  <td><ExtendedButton
                    Usable={true}
                    Float={'left'}
                    Width={32}
                    Height={32}
                    Type={"Round"} 
                    Text={<Icon
                      ref={"IconAddSibling"}
                      AppURL={this.props.AppURL}
                      Name={"Add"}
                      Size={18}
                      Color={"black"}
                      Align={"left"}
                      PaddingRight={'5px'}
                      PaddingTop={'1px'} />}  
                    OnClick={()=>{this.addSibling();}} /></td>
                </tr>
              </tbody>
            </table>
            <table
                      id={"sibling2"}
                      className={"LegalGuardianNotVisible"}>
                      <tbody>
                        <tr><td colSpan="2"><b>{Vas.Resources.Labels["Child2"]}</b></td></tr>
                        <tr>
                          <td><TextField
                            AppURL={Vas.ApplicationUrl}
                            Editable={true}
                            Id={"nameS2"}
                            Label={Vas.Resources.Labels["Name"]}
                            OnChange={()=>{ this.Sibling2.Name1 = $("#nameS2").val(); }}
                            Modus={"Name"} 
                            OnBlur={()=>{this.numberSibling();this.siblingSetRequiredSymbol("2");}}
                            /></td>
                          <td><TextField
                            AppURL={Vas.ApplicationUrl}
                            Editable={true}
                            Id="firstNameS2"
                            Label={Vas.Resources.Labels["FirstName"]}
                            OnChange={()=>{ this.Sibling2.Name2= $("#firstNameS2").val(); }} 
                            Modus={"Name"}
                            OnBlur={()=>{this.numberSibling();this.siblingSetRequiredSymbol("2");}}
                            /></td>
                        </tr>
                        <tr>
                          <td><DateField
                            AppURL={Vas.ApplicationUrl}
                            Language={localStorage.getItem("vas_language")}
                            Editable={true}
                            Id={"DateOfBirthS2"}
                            MaxValue={maxValue}
                            MinValue={minValue}
                            Tooltip={Vas.Resources.Tooltips["DateOfBirth"]} 
                            Label={Vas.Resources.Labels["DateOfBirth"]}
                            OnBlur={()=>{this.Sibling2.DateOfBirth = $("#DateOfBirthS2").val(); this.numberSibling();this.siblingSetRequiredSymbol("2");}}
                            FalseMaxDateText={Vas.Resources.Labels["NoFutureDateOfBirth"]}
                            FalseMinDateText={Vas.Resources.Labels["InvalidDateOfBirth"]} /></td>
                          <td><TextField
                            AppURL={Vas.ApplicationUrl}
                            Editable={true}
                            Id={"accountNumberS2"}
                            Label={Vas.Resources.Labels["CustomerNumber"]}
                            OnChange={()=>{ this.Sibling2.CustomerNumber = $("#accountNumberS2").val();this.siblingSetRequiredSymbol("2"); }} /></td>
                        </tr>
                      </tbody>
                    </table>
          </div>
        );
      }

      setStepperContract(){

        if(contractStartEndDatesSet == false){
          this.getContractEndParams();
        }

        return(
          <table style={{ width:'350px' }}>
            <tbody>
              <tr>
                <td colSpan={2}><p style={{ textAlign: 'left' }}><b>{Vas.Resources.Titles["Note"]}: </b><i className={"HintFormat"}>{Vas.Resources.Labels["NoteProduct"]}</i></p></td>
              </tr>
              <tr>
                <td>
                  <div id={"StartEndRegio"}>

                  </div>
                </td>
              </tr>
              <tr>
                <td colSpan={2}><TextField
                  AppURL={Vas.ApplicationUrl}
                  me={this}
                  Width={300}
                  ref={"schoolPlace"}
                  Editable={true}
                  IsRequired={true}
                  Id={"SchoolPlace"}
                  Tooltip={Vas.Resources.Tooltips["SchoolPlace"]}
                  OnBlur={()=>{this.clearAll(2); this.setState({ schoolPlace: $("#SchoolPlace").val() },()=>{ this.getSchools();});   }}
                  Label={Vas.Resources.Labels["SchoolPlace"]} /></td>
              </tr>
              <tr>
                <td colSpan={2}><SelectField
                  AppURL={Vas.ApplicationUrl}
                  me={this}
                  Width={300}
                  ref={"school"}
                  Id={"Schools2"}
                  Editable={true}
                  IsRequired={true}
                  Tooltip={Vas.Resources.Tooltips["School"]}
                  Label={Vas.Resources.Labels["School"]}
                  OnChange={()=>{this.clearAll(3);this.setState({ SchoolId: $("#Schools2").val() }); this.getProducts();}} /></td>
              </tr>
              
              <tr>
                <td colSpan={2}><SelectField
                  AppURL={Vas.ApplicationUrl}
                  me={this}
                  Width={300}
                  ref={"products"}
                  Id={"Product"}
                  Float={'left'}
                  IsRequired={true}
                  Label={Vas.Resources.Labels["Product"]}
                  OnChange={()=>{this.clearAll(4);this.setState({ Product: $("#Product").val() },()=>{this.getContractEndParams();});this.getRelation(); }}
                  Tooltip={Vas.Resources.Tooltips["Product"]} /></td>
              </tr>
              <tr>
                <td colSpan={2}><SelectField
                  AppURL={Vas.ApplicationUrl}
                  me={this}
                  Width={300}
                  ref={"relations"}
                  Id={"Relation"}
                  Float={'left'}
                  IsRequired={true}
                  Label={Vas.Resources.Labels["Connection"]}
                  OnChange={()=>{this.clearAll(5);this.setState({ Relation:$("#Relation").val() }); this.setRelation(); }}
                  Tooltip={Vas.Resources.Tooltips["Connection"]} /></td>
              </tr>
              <tr>
                <td><p style={{ fontSize:'12px', margin:'0px' }}>{Vas.Resources.Labels["RequiredField"]}</p><br /></td>
              </tr>
            </tbody>
          </table>
        );
      }

      setStepperTariff(){

        return(
          <table style={{ width:'350px' }}>
            <tbody>
              <tr>
                <td colSpan={2}><p style={{ textAlign: 'left' }}><b>{ Vas.Resources.Titles["Note"] }: </b><i className={'HintFormat'} >{Vas.Resources.Labels["NoteConnection"]}</i></p></td>
              </tr>
              <tr>
                <td colSpan={2}><TextField
                  AppURL={Vas.ApplicationUrl}
                  me={this}
                  ref={"from"}
                  Width={300}
                  Editable={false}
                  IsRequired={true}
                  Id="From"
                  Label={Vas.Resources.Labels["From"]}
                  Value={this.state.From} /></td>
              </tr>
              <tr>
                <td colSpan={2}><TextField
                  AppURL={Vas.ApplicationUrl}
                  me={this}
                  ref={"to"}
                  Width={300}
                  Editable={false}
                  IsRequired={true}
                  Id="To"
                  Label={Vas.Resources.Labels["To"]}
                  Value={this.state.To} /></td>
              </tr>
              <tr>
                <td colSpan={2}><TextField
                  AppURL={Vas.ApplicationUrl}
                  me={this}
                  ref={"via"}
                  Width={300}
                  Editable={false}
                  IsRequired={true}
                  Id="Via"
                  Label={Vas.Resources.Labels["Via"]}
                  Value={this.state.Via} /></td>
              </tr>
              <tr>
                <td><p style={{ fontSize:'12px', margin:'0px' }}>{Vas.Resources.Labels["RequiredField"]}</p><br /></td>
              </tr>
            </tbody>
          </table>
        );
      }

      setStepperPaymentOrder(){

        return(
          <table style={{ width:'350px' }}>
            <tbody>
              <tr>
                <td><TextField
                  AppURL={Vas.ApplicationUrl}
                  me={this}
                  ref={"productPrice"}
                  Width={80}
                  Editable={false}
                  IsRequired={true}
                  Id="ProductPrice"
                  Label={Vas.Resources.Labels["ProductPrice"]}
                  Value={this.state.Price} /> </td>
              </tr>
              <tr>
                <td colSpan={2}>
                  <SelectField
                    AppURL={Vas.ApplicationUrl}
                    me={this}
                    Width={300}
                    ref={"Payment"}
                    Id={"Payments"}
                    Editable={true}
                    IsRequired={true}
                    Tooltip={Vas.Resources.Tooltips["Payment"]}
                    Label={Vas.Resources.Labels["MethodOfPaymentCustomer"]}
                    OnChange={()=>{ this.setState({ Payment: $("#Payments").val() });}} />   
                </td>
              </tr>
              <tr>
                <td colSpan={5} style={{ paddingTop: '4px'}}>
                  <Checkbox
                    ref={"AcceptPaymentTerms"}
                    Id={"checkboxAcceptPaymentTerms"}
                    onClick={()=>{this.setState({ AcceptPaymentTerms:$("#checkboxAcceptPaymentTerms").val() });}} />
                {/* </td>
              </tr>
              <tr>
                <td colSpan={3}> */}
                  <div style={{ textAlign:'left' }} >
                    <i className={'HintFormat'}>
                      {Vas.Resources.Labels["PaymentText"]}*
                    </i>                            
                  </div>
                </td>
              </tr>
              <tr>
                <td><p style={{ textAlign: 'left' }}>{Vas.Resources.Labels["RequiredField"]}</p><br /></td>
              </tr>
            </tbody>
          </table>
        );
      }

      setStepperTariffing(){

        return(
          <table style={{ width:'350px' }}>
            <tbody>
              <tr>
                <td>
                  <div>
                    <AutocompleteField 
                      Autocomplete={false} 
                      AppURL={Vas.ApplicationUrl} 
                      TitleMessageFalseStreet={Vas.Resources.Labels["Error"]} 
                      MessageFalseStreet={Vas.Resources.Labels["FalseProduct"]} 
                      Modus={"TariffPoint"} 
                      editable={true} 
                      ref={"From"} 
                      Id={"From"} 
                      Float={'left'} 
                      IsRequired={true} 
                      Label={Vas.Resources.Labels["From"]} 
                      OnChange={()=>{this.Search("From");}} 
                      Function={()=>{this.GetVia();}} 
                      PriceInfoText={Vas.Resources.Labels["ProductPrice"]+ " " +Vas.Resources.Labels["inEuro"]}
                      Width={300}
                      Project={"DBBUS"} 
                      TimeOutTime={Vas.TimeOutTime} />
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div>
                    <AutocompleteField 
                      Autocomplete={false} 
                      AppURL={Vas.ApplicationUrl} 
                      TitleMessageFalseStreet={Vas.Resources.Labels["Error"]} 
                      MessageFalseStreet={Vas.Resources.Labels["FalseProduct"]}
                      Modus={"TariffPoint"} 
                      editable={true} 
                      ref={"To"} 
                      Id={"To"} 
                      Float={'left'} 
                      IsRequired={true} 
                      Label={Vas.Resources.Labels["To"]} 
                      OnChange={()=>{this.Search("To");}} 
                      Function={()=>{this.GetVia();}} 
                      PriceInfoText={Vas.Resources.Labels["ProductPrice"]+ " " +Vas.Resources.Labels["inEuro"]}
                      Width={300}
                      Project={"DBBUS"}
                      TimeOutTime={Vas.TimeOutTime} />
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div>
                    <SelectField 
                      AppURL={Vas.ApplicationUrl} 
                      ref={"Via"} 
                      Id={"Via"} 
                      Float={'left'} 
                      IsRequired={true} 
                      Label={Vas.Resources.Labels["Via"]} 
                      OnChange={()=>{this.setState({ Via:$("#Via").val() },()=>{this.getContractEndParams();this.setPrice();});}} 
                      PriceInfoText={Vas.Resources.Labels["ProductPrice"]+ " " +Vas.Resources.Labels["inEuro"]}
                      Width={300} />
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div id={"StartEndRegio"}>

                  </div>
                </td>
              </tr>
              <tr>
                <td id={"PriceInformation"}>
                  <TextField 
                    AppURL={Vas.ApplicationUrl} 
                    ref={"Price"} 
                    Editable={false} 
                    Id={"Price"} 
                    Label={Vas.Resources.Labels["ProductPrice"]+ " " +Vas.Resources.Labels["inEuro"]} 
                    OnBlur={()=>{this.removePrice();}} />
                </td>
              </tr>  
                            
              <tr>
                <td><p>{Vas.Resources.Labels["RequiredField"]}</p><br /></td>
              </tr>
            </tbody>
          </table>
        );
      }

      setStepperPaymentOrderSchulträger(){

        return(
          <table style={{ width:'350px' }}>
            <tbody>
              <tr>
                <td colSpan={2}><p><b>{Vas.Resources.Titles["Note"]}:</b> <i className={"HintFormat"}>{Vas.Resources.Labels["NotePayment"]}</i> </p></td>
              </tr>
              <tr>
                <td colSpan={2}>
                  <SelectField
                    AppURL={Vas.ApplicationUrl}
                    me={this}
                    Width={300}
                    ref={"Payment"}
                    Id={"Payments"}
                    Editable={true}
                    IsRequired={true}
                    Tooltip={Vas.Resources.Tooltips["Payment"]}
                    Label={Vas.Resources.Labels["MethodOfPaymentCustomer"]}
                    OnChange={()=>{ this.setState({ Payment: $("#Payments").val() });}} />   
                </td>
              </tr>
            </tbody>
          </table>
        );
      }
//#endregion
      
      render()
      {    
        if ($("#From").val() === ""){        
          $("#From").addClass("grayBackgroundColor");
        }

        if ($("#To").val() === ""){
            $("#To").addClass("grayBackgroundColor");
        }

        if ($("#Via").val() == null){
            $("#Via").addClass("grayBackgroundColor");
        }
        else {
            if ($("#Via").hasClass("grayBackgroundColor")){
                $("#Via").removeClass("grayBackgroundColor");
            }
            else {
                document.getElementById("Via").style.backgroundColor = "white";
            }            
        }
        
        let tariffing;
        if (this.state.role==="1"){
          let siblingStep = StepperTable.buildStepperTable(1,4,Vas.Resources.Labels["Siblings"],this.setStepperSiblings(),true,false,false,null,null);
          let contractStep = StepperTable.buildStepperTable(2,4,Vas.Resources.Labels["ContractData"],this.setStepperContract(),true,true,false,null,null);
          let tariffStep = StepperTable.buildStepperTable(3,4,Vas.Resources.Labels["Product"],this.setStepperTariff(),true,true,false,null,null);
          let orderStep = StepperTable.buildStepperTable(4,4,Vas.Resources.Labels["Price"] + " & " +Vas.Resources.Labels["MethodOfPaymentCustomer"], this.setStepperPaymentOrder(),false,true,true,null,()=>{ this.checkFields();});

          tariffing = (<div>
            {siblingStep}
            {contractStep}
            {tariffStep}
            {orderStep}
          </div>
          );
        } else {
          let tariffStep = StepperTable.buildStepperTable(1,2,Vas.Resources.Labels["ContractData"],this.setStepperTariffing(),true,false,false,null,null);
          let orderStep = StepperTable.buildStepperTable(2,2,Vas.Resources.Labels["MethodOfPaymentCustomer"],this.setStepperPaymentOrderSchulträger(),false,true,true,null,()=>{ this.checkFields();});
          tariffing = (<div>
            {tariffStep}
            {orderStep}
          </div>
          );
        }

        return (<div>
          <table
            className={"customerCard"}
            style={{ textAlign:'initial', width:'500px', display:'inline-block',overflowY:'hidden' }}>
            <thead>
              <tr>
                <th style={{ float:"right", lineHeight:"30px", paddingRight:"20px", paddingTop:"10px" }}>
                  <div id={"LoadingIconPopUp"}></div>
                </th>
              </tr>
              <tr>
                <th>
                  <h2>{Vas.Resources.Labels["OrderSchoolTicket"]} </h2>
                </th>
              </tr>
              <tr>
                <th>
                  {this.state.CustomerText}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  {tariffing}
                </td>
              </tr>
            </tbody>
          </table>
        </div>);
      }
}
export default CustomerCreateContract;
